//TODO: Reaplace with const from hero section
export const RatingInfo = {
  current: 4.6,
  max: 5,
};
